export default __webpack_public_path__ + "img/component-info-2.4c7eaa62.png";